import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Grid,
  Typography,
  TextField,
  Switch,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Tooltip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import graphqlRequest from "../../../requestMethod";
import "./EditJobModal.scss";

import { message } from "../SnakeAlert/SnakeAlert";
import { pushEvent } from "../../../utils/clevertap";


const EditJobModal = ({ open, onClose, selectedData, editOpenJob }) => {
  const [formData, setFormData] = useState({
    professional: "",
    hours: "",
    startDate: "",
    startTime: "",
    rate: "",
    isCamp: false,
    cost: "",
    updatedAt: "",
    updatedBy: "",
    marginPercentage: "",
    updatedSource: "",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [initialData, setInitialData] = useState({});
  const [disableProfessional, setDisableProfessional] = useState(false);


  const token = JSON.parse(localStorage.getItem("auth"))?.accessToken;

  // Prefill data
  // useEffect(() => {
  //   if (selectedData && open) {
  //     const rawDateTime = selectedData?.startEndDate;

  //     setFormData({
  //       professional: selectedData?.positionAvailable || "",
  //       hours: selectedData?.shiftHours || "",
  //       startDate: rawDateTime
  //         ? dayjs(rawDateTime).format("YYYY-MM-DD")
  //         : "",
  //       startTime: rawDateTime
  //         ? dayjs(rawDateTime).format("HH:mm")
  //         : "",
  //       rate: selectedData?.shiftRate || "",
  //       isCamp: selectedData?.isCamp === "Yes",
  //       cost: selectedData?.cost || "",
  //       updatedAt: selectedData?.updatedAt
  //         ? dayjs(selectedData.updatedAt).format("DD MMM YYYY, hh:mm A")
  //         : "",
  //       updatedBy: selectedData?.updatedBy || "",
  //     });
  //   }
  // }, [selectedData, open]);

  useEffect(() => {
    if (selectedData && open) {
      const rawDateTime = selectedData?.startEndDate;
  
      const prefilled = {
        professional: selectedData?.positionAvailable || "",
        hours: selectedData?.shiftHours || "",
        updatedSource: selectedData?.updatedSource || "",
        marginPercentage: selectedData?.marginPercentage || "",

        startDate: rawDateTime
          ? dayjs(rawDateTime).format("YYYY-MM-DD")
          : "",
        startTime: rawDateTime
          ? dayjs(rawDateTime).format("HH:mm")
          : "",
        rate: selectedData?.shiftRate || "",
        isCamp: selectedData?.isCamp === "Yes",
      };
  
      setFormData({
        ...prefilled,
        cost: selectedData?.cost || "",
        updatedSource: selectedData?.updatedSource || "",
        marginPercentage: selectedData?.marginPercentage || "",
        updatedAt: selectedData?.updatedAt
          ? dayjs(selectedData.updatedAt).format("DD MMM YYYY, hh:mm A")
          : "",
        updatedBy: selectedData?.updatedBy || "",
      });
  
      // 👇 store original snapshot
      // setInitialData(prefilled);
      setInitialData({
        ...prefilled,
        cost: selectedData?.cost || "",
        marginPercentage: selectedData?.marginPercentage || "",
      });
      if (rawDateTime) {
        const jobStart = dayjs(rawDateTime);
        const now = dayjs();
        const diffInHours = jobStart.diff(now, "hour", true);
  
        setDisableProfessional(diffInHours <= 3);
      }
      
    }
  }, [selectedData, open]);
  

  useEffect(() => {
    if (!open) {
      setErrorMsg("");
    }
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prev) => {
      let updated = { ...prev, [name]: value };
  
      // ✅ If date changes, validate startTime again
      if (name === "startDate" && prev.startTime) {
        const now = new Date();
        const today = now.toISOString().split("T")[0];
  
        if (value === today) {
          const [hour, minute] = prev.startTime.split(":").map(Number);
          const selectedMinutes = hour * 60 + minute;
          const currentMinutes = now.getHours() * 60 + now.getMinutes();
  
          // ❗ If old time is past → clear it
          if (selectedMinutes <= currentMinutes) {
            updated.startTime = "";
          }
        }
      }
  
      return updated;
    });
  };
  

  const handleSwitchChange = (e) => {
    setFormData((prev) => ({ ...prev, isCamp: e.target.checked }));
  };
  const now = new Date();
  const today = now.toISOString().split("T")[0];
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  const generateTimeOptions = () => {
    const options = [];
    try {
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
          const timeString = `${hour.toString().padStart(2, "0")}:${minute
            .toString()
            .padStart(2, "0")}`;
          options.push(timeString);
        }
      }
    } catch (error) {
      console.error("Error generating time options:", error);
    }
    return options;
  };

  const timeOptions = generateTimeOptions();

  const handleSave = async () => {
    setIsSubmitting(true);
    setErrorMsg("");
    if (
      !formData.professional ||
      !formData.hours ||
      !formData.startDate ||
      !formData.startTime ||
      !formData.rate
    ) {
      message.error("All fields are required");
      setIsSubmitting(false);
      return;
    }
    if (
      Number(formData.professional) <= 0 ||
      Number(formData.hours) <= 0 ||
      Number(formData.rate) <= 0
    ) {
      message.error("Professional, Hours and Rate must be greater than 0");
      setIsSubmitting(false);
      return;
    }
    const payload = {};
  
    // compare & add only changed fields
    if (formData.startDate !== initialData.startDate) {
      payload.startDate = `"${formData.startDate}"`;
    }
  
    if (formData.startTime !== initialData.startTime) {
      payload.startTime = `"${formData.startTime}"`;
    }
  
    if (Number(formData.hours) !== Number(initialData.hours)) {
      payload.shiftHours = Number(formData.hours);
    }
  
    if (Number(formData.rate) !== Number(initialData.rate)) {
      payload.maxRate = Number(formData.rate);
    }
  
    if (formData.isCamp !== initialData.isCamp) {
      payload.campDuty = formData.isCamp;
    }
  
    if (Number(formData.professional) !== Number(initialData.professional)) {
      payload.numberOfJobs = Number(formData.professional);
    }
  
    // ❗ if nothing changed, avoid API call
    if (Object.keys(payload).length === 0) {
      message.info("No changes detected");
      setIsSubmitting(false);
      return;
    }
  
    // Convert payload to GraphQL args
    const dynamicArgs = Object.entries(payload)
      .map(([key, value]) => `${key}: ${value}`)
      .join(",\n");
  
    const query = `
  mutation {
    mutationWithAuth(token: "${token}") {
      update {
        updateJobNew(
          jobId: "${selectedData?.id}",
          ${dynamicArgs}
        ) {
          success
          message
        }
      }
    }
  }
  `;
  
    try {
      const response = await graphqlRequest(query);
      const result =
        response?.data?.mutationWithAuth?.update?.updateJobNew;
  
      if (result?.success) {
        pushEvent("Web_JobEdit", {
          page: "Open Jobs",
          section: "Jobs",
          jobId: selectedData?.id,
          ...payload
        });
        editOpenJob();
        onClose();
        message.success(result?.message);
      } else {
        message.error(result?.message || "Failed to update job");
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };
  const hasChanges = () => {
    return (
      formData.startDate !== initialData.startDate ||
      formData.startTime !== initialData.startTime ||
      Number(formData.hours) !== Number(initialData.hours) ||
      Number(formData.rate) !== Number(initialData.rate) ||
      formData.isCamp !== initialData.isCamp ||
      Number(formData.professional) !== Number(initialData.professional)
    );
  };
  
  
//   const handleSave = async () => {
//     setIsSubmitting(true);
//     setErrorMsg("");

//     const { hours, startDate, startTime, rate, isCamp, professional } =
//       formData;

//     const query = `
// mutation {
//   mutationWithAuth(token: "${token}") {
//     update {
//       updateJobNew(
//         jobId: "${selectedData?.id}",
//         startDate: "${startDate}",
//         startTime: "${startTime}",
//         shiftHours: ${Number(hours)},
//         maxRate: ${Number(rate)},
//         campDuty: ${isCamp},
//         numberOfJobs: ${Number(professional)}
//       ) {
//         success
//         message
//       }
//     }
//   }
// }
// `;

//     try {
//       const response = await graphqlRequest(query);
//       const result =
//         response?.data?.mutationWithAuth?.update?.updateJobNew;

//       if (result?.success) {
//         editOpenJob(); // refresh list
//         onClose();
//         message.success(result?.message);

//       } else {
//         message.error(result?.message || "Failed to update job");
//         // setErrorMsg(result?.message || "Failed to update job");
//       }
//     } catch (error) {
//       console.error(error);
//       message.error("Something went wrong");

//       // setErrorMsg("Something went wrong");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
  const unifiedFieldStyle = {
    height: "48px",
    width: '100%',
    borderRadius: "8px",
    backgroundColor: "white",
    "& .MuiOutlinedInput-root": {
      border: "1px solid transparent",
      borderRadius: "8px",
      transition: "border 0.2s ease",
      height: '100%',
      "&:hover": {
        border: "1px solid transparent",
      },
      "&.Mui-focused": {
        border: "2px solid #1976d2",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        display: "none",
      },
    },
    "& .MuiInputLabel-root": {
      backgroundColor: "#fff",
      padding: "0 4px",
      zIndex: 1,
      fontSize: isMobile ? '0.875rem' : '1rem',
    },
    "& .MuiInputBase-input": {
      fontSize: isMobile ? '0.875rem' : '1rem',
      height: '100%',
      padding: isMobile ? '8px 14px' : '14px',
    },
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="edit-job-modal">
        {/* HEADER */}
        <Box className="modal-header">
          <Typography className="title">
            Edit Job: <span>{selectedData?.jobId}</span>
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* BODY */}
        <Box className="modal-body">
          <Grid container spacing={1.5}>
            <Grid item xs={12} md={6}>
                                                  <Tooltip title={disableProfessional?"Editing disabled within 3 hours of start time.":null} arrow>
{/*               
            <TextField
              fullWidth
              type="number"
              name="professional"
              label="No. of Professional"
              // helperText={isWithinThreeHours() ? "Editing disabled within 3 hours of start time." : ""}
              variant="outlined"
              value={formData.professional}
              disabled={disableProfessional}
              onChange={handleChange}
              InputLabelProps={{ 
                shrink: true,
                style: {
                  fontSize: isMobile ? '0.875rem' : '1rem',
                }
              }}
              inputProps={{
                // min: today,
                style: {
                  height: "48px",
                  boxSizing: "border-box",
                  padding: "0 14px",
                  fontSize: isMobile ? '0.875rem' : '1rem',
                },
              }}
              // onChange={(e) =>
              //   setEditForm({ ...editForm, startDate: e.target.value })
              // }
              sx={unifiedFieldStyle}
            /> */}
            <Box className="form-group">
      <Typography className="label" style={{ color: "#1976d2" }}>No. of Professional</Typography>
      <TextField
        name="professional"
        type="number"
        value={formData.professional}
        onChange={handleChange}
        disabled={disableProfessional}
        className="input-clean"
        variant="outlined"
        fullWidth
      />
    </Box>
            </Tooltip>
            </Grid>

            <Grid item xs={12} md={6}>
              {/* <TextField
                label="No. of Hours"
                name="hours"
                type="number"
                // size="small"
                fullWidth
                sx={{ height: "60px" }}
                value={formData.hours}
                onChange={handleChange}
              /> */}
                                                  <Tooltip title={disableProfessional?"Editing disabled within 3 hours of start time.":null} arrow>

               {/* <TextField
              fullWidth
              label="No. of Hours"
              name="hours"
              type="number"
              variant="outlined"
              value={formData.hours}
              onChange={handleChange}
              disabled={disableProfessional}
              InputLabelProps={{ 
                shrink: true,
                style: {
                  fontSize: isMobile ? '0.875rem' : '1rem',
                }
              }}
              inputProps={{
                // min: today,
                style: {
                  height: "48px",
                  boxSizing: "border-box",
                  padding: "0 14px",
                  fontSize: isMobile ? '0.875rem' : '1rem',
                },
              }}
              // onChange={(e) =>
              //   setEditForm({ ...editForm, startDate: e.target.value })
              // }
              sx={unifiedFieldStyle}
            /> */}
             <Box className="form-group">
      <Typography className="label" style={{ color: "#1976d2" }}>No. of Hours</Typography>
      <TextField
        name="hours"
        type="number"
        value={formData.hours}
        onChange={handleChange}
        disabled={disableProfessional}
        className="input-clean"
        variant="outlined"
        fullWidth
      />
    </Box>
            </Tooltip>
            </Grid>

            <Grid item xs={12} md={6}>
            <Tooltip title={disableProfessional?"Editing disabled within 3 hours of start time.":null} arrow>
            
               {/* <TextField
              fullWidth
              type="date"
              label="Start Date"
              name="startDate"
              variant="outlined"
              value={formData.startDate}
              disabled={disableProfessional}
              onChange={handleChange}
              InputLabelProps={{ 
                shrink: true,
                style: {
                  fontSize: isMobile ? '0.875rem' : '1rem',
                }
              }}
              inputProps={{
                min: today,
                style: {
                  height: "48px",
                  boxSizing: "border-box",
                  padding: "0 14px",
                  fontSize: isMobile ? '0.875rem' : '1rem',
                },
              }}
              sx={unifiedFieldStyle}
            /> */}
            <Box className="form-group">
      <Typography className="label" style={{ color: "#1976d2" }}>Start Date</Typography>
      <TextField
        name="startDate"
        type="date"
        value={formData.startDate}
        onChange={handleChange}
        disabled={disableProfessional}
        inputProps={{ min: today }}
        className="input-clean"
        variant="outlined"
        fullWidth
      />
    </Box>
            </Tooltip>
            </Grid>

            

            <Grid item xs={12} md={6}>
                {/* <TextField
              fullWidth
              label="Rate (₹/hour)"
                name="rate"
              type="number"
              variant="outlined"
              value={formData.rate}
              onChange={handleChange}
              InputLabelProps={{ 
                shrink: true,
                style: {
                  fontSize: isMobile ? '0.875rem' : '1rem',
                }
              }}
              inputProps={{
                style: {
                  height: "48px",
                  boxSizing: "border-box",
                  padding: "0 14px",
                  fontSize: isMobile ? '0.875rem' : '1rem',
                },
              }}
              sx={unifiedFieldStyle}
            /> */}
            <Box className="form-group">
      <Typography className="label" style={{ color: "#1976d2" }}>Rate (₹/hour)</Typography>
      <TextField
        name="rate"
        type="number"
        value={formData.rate}
        onChange={handleChange}
        className="input-clean"
        variant="outlined"
        fullWidth
      />
    </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
            {/* <FormControl fullWidth sx={{ 
              ...unifiedFieldStyle, 
              height: 'auto',
              border: '1px solid #c4c4c4',
              borderRadius: '8px',
              '&:hover': {
                border: '1px solid #000',
              },
              '&.Mui-focused': {
                border: '2px solid #1976d2',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            }}>
              <InputLabel sx={{ 
                fontSize: isMobile ? '0.875rem' : '1rem',
                '&.Mui-focused': {
                  color: 'rgba(0, 0, 0, 0.6)',
                },
              }}>
                Start Time
              </InputLabel> */}
              <Tooltip title={disableProfessional?"Editing disabled within 3 hours of start time.":null} arrow>
              <Box className="form-group">
      <Typography className="label" style={{ color: "#1976d2" }}>Start Time</Typography>
      <Select
        name="startTime"
        value={formData.startTime}
        onChange={handleChange}
        disabled={disableProfessional}
        className="select-clean"
        fullWidth
        sx={{
          // background: "#f9fafb",
          borderRadius: "7px",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        }}
      

>
        <MenuItem value="">Select time</MenuItem>
        {timeOptions.map((time) => {
          const isToday = formData.startDate === today;
          const [hour, minute] = time.split(":").map(Number);
          const timeInMinutes = hour * 60 + minute;
          const currentTimeInMinutes =
            currentHour * 60 + currentMinute;

          const isValid =
            !isToday || timeInMinutes > currentTimeInMinutes;

          return isValid ? (
            <MenuItem key={time} value={time}>
              {time}
            </MenuItem>
          ) : null;
        })}
      </Select>
    </Box>
              {/* <Select
               value={formData.startTime}
               onChange={handleChange}
              disabled={disableProfessional}
               name="startTime"
                label="Start Time"
                sx={{
                  ...unifiedFieldStyle,
                  height: '48px',
                  '& .MuiSelect-select': {
                    fontSize: isMobile ? '0.875rem' : '1rem',
                    padding: isMobile ? '8px 32px 8px 14px' : '14px 32px 14px 14px',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
              >
                
                <MenuItem value="">Select time</MenuItem>
                {timeOptions.map((time) => {
                  const isToday = formData.startDate === today;
                  const [hour, minute] = time.split(":").map(Number);
                  const timeInMinutes = hour * 60 + minute;
                  const currentTimeInMinutes = currentHour * 60 + currentMinute;
                  const isInFuture =
                    !isToday || timeInMinutes > currentTimeInMinutes;

                  return isInFuture ? (
                    <MenuItem 
                      key={time} 
                      value={time}
                      sx={{ fontSize: isMobile ? '0.875rem' : '1rem' }}
                    >
                      {time}
                    </MenuItem>
                  ) : null;
                })}
              </Select> */}
              </Tooltip>
            {/* </FormControl> */}
          </Grid>

            {/* CAMP DUTY */}
            <Grid item xs={12} md={6}>
              {/* <Box className="camp-duty-card">
                <Typography className="camp-title">Camp Duty</Typography>
                <Box className="camp-switch">
                  <Switch
                    checked={formData.isCamp}
                    onChange={handleSwitchChange}
                  />
                  <Typography
                    className={formData.isCamp ? "yes" : "no"}
                  >
                    {formData.isCamp ? "Yes" : "No"}
                  </Typography>
                </Box>
              </Box> */}
                 <Box className="form-group">
      <Typography className="label no-transform" style={{ color: "#1976d2" }}>
        Camp Duty
      </Typography>

      <Box className="switch-box">
        <Switch
          checked={formData.isCamp}
          onChange={handleSwitchChange}
        />
        <Typography className="switch-text">
          {formData.isCamp ? "Yes" : "No"}
        </Typography>
      </Box>
    </Box>
            </Grid>
          </Grid>

          {/* COST SUMMARY */}
          <div className="cost-summary-card">
          <div className="card-modern card-hover">
          <Box className="cost-summary">
            {/* <Typography className="summary-title">Cost Summary (Inclusive of convenience fees {formData.marginPercentage}% and 18% GST)</Typography> */}
            <Typography className="summary-title">
  Cost Summary
  <br/>
  <span className="summary-sub">
    (Inclusive of convenience fees {formData.marginPercentage}% and 18% GST)
  </span>
</Typography>
            <Box className="summary-row">
              <Typography>Original Cost</Typography>
              <Typography className="amount muted">
                {/* ₹{formData.cost * 0.18 * formData.marginPercentage/100} */}
                {/* ₹{(
  Number(formData.cost) *
  (1 + Number(formData.marginPercentage) / 100 * 1.18)
).toFixed(2)} */}
₹{
  initialData.cost && initialData.professional
    ? (
        Number(initialData.cost) *
        Number(initialData.professional) *
        (1 + (Number(initialData.marginPercentage) / 100) * 1.18)
      ).toFixed(2)
    : 0
}


              </Typography>
            </Box>

            <Box className="summary-row highlight">
              <Typography>New Cost</Typography>
              {/* <Typography className="amount">
                ₹
                {formData.hours && formData.rate
                  ? formData.hours * formData.rate
                  : 0}
              </Typography> */}
              <Typography className="amount">
  {/* ₹
  {formData.hours && formData.rate && formData.professional
    ? Number(formData.hours) *
      Number(formData.rate) *
      Number(formData.professional)
    : 0} */}
    ₹{
  formData.hours && formData.rate && formData.professional
    ? (
        Number(formData.hours) *
        Number(formData.rate) *
        Number(formData.professional) *
        (1 + (Number(formData.marginPercentage) / 100) * 1.18)
      ).toFixed(2)
    : 0
}

</Typography>

            </Box>
          </Box>
          </div>
          </div>

  
  <Typography className="updated-by" style={{fontSize: '13px'}}>
            Last Updated By: {formData.updatedSource==="WEBAPP"? formData.updatedBy : formData.updatedSource} · {formData.updatedAt}
          </Typography>

          {errorMsg && (
            <Typography color="error" mt={2}>
              {errorMsg}
            </Typography>
          )}
        </Box>

        {/* FOOTER */}
        <Box className="modal-footer">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={isSubmitting || !hasChanges()}
          >
            {isSubmitting ? "Saving..." : "Save Changes"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditJobModal;
